import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export function SignaturePad({ onChange }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#111";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
    dirty.current = true;
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (dirty.current) { setEmpty(false); onChange(ref.current.toDataURL("image/png")); }
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    dirty.current = false;
    setEmpty(true);
    onChange("");
  };

  return (
    <div>
      <canvas ref={ref} data-testid="signature-canvas" aria-label="Draw your signature" onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className="w-full h-40 rounded-lg border-2 border-dashed border-stone-300 bg-snow touch-none cursor-crosshair" />
      <div className="mt-1 flex items-center justify-between text-xs text-stone-500">
        <span>{empty ? "Sign above with your finger, stylus or mouse" : "Signature captured"}</span>
        <button type="button" data-testid="signature-clear" onClick={clear} className="inline-flex items-center gap-1 h-9 px-2 rounded hover:bg-stone-100"><Eraser className="h-3.5 w-3.5" />Clear</button>
      </div>
    </div>
  );
}
